import { render, staticRenderFns } from "./JInputPopup.vue?vue&type=template&id=580b1694&scoped=true&"
import script from "./JInputPopup.vue?vue&type=script&lang=js&"
export * from "./JInputPopup.vue?vue&type=script&lang=js&"
import style0 from "./JInputPopup.vue?vue&type=style&index=0&id=580b1694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b1694",
  null
  
)

export default component.exports